import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { StrapiMediaDTO } from "@lib/strapi/dtos/core/media.dto";
import {
  StrapiLinkDTO,
  LinkDTO,
} from "@lib/strapi/dtos/components/shared/link.dto";
import { ImageProps } from "@lib/image";

export interface StrapiPageHeadingDTO extends StrapiDynamicZoneComponentDTO {
  title: string;
  subtitle: string;
  className: string;
  image: StrapiMediaDTO;
  links: StrapiLinkDTO[];
}

export class PageHeadingDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  title: string;
  subtitle: string;
  className: string;
  image: ImageProps;
  links: LinkDTO[];
}
